module.exports = __webpack_public_path__ + "img/06.d043a69c.jpg";